import React, { useState, useEffect } from "react";
import s from "./searchModal.module.css";

import {
  Modal,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Button,
  Grid,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es";
import "dayjs/locale/pt";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDate } from "../../../../helpers/convertDate";
import SearchIcon from "@mui/icons-material/Search";
import AgencyModal from "../../../Shared/AgencyModal";
import ProvidersModal from "../../../Shared/ProvidersModal";

const SearchModal = ({
  setActualPage,
  open,
  closeModal,
  setSearching,
  setFilters,
  filters,
  setNewFilters,
}) => {
  const { t } = useTranslation();
  const { language } = useSelector((state) => state.local);
  const [search, setSearch] = useState("proveedor");

  const [agencieSelect, setAgencieSelect] = useState({ name: t("agency") });
  const [providerSelect, setProviderSelect] = useState({
    businessName: t("provider"),
  });
  const [openAgencyModal, setOpenAgencyModal] = useState(false);
  const [openProviderModal, setOpenProviderModal] = useState(false);

  const handleClose = () => {
    setFilters({
      number: 0,
      type: "any",
      dateRemit: null,
      state: "any",
      agency: "all",
      provider: "all",
      orderID: 0,
    });
    setAgencieSelect({ name: t("agency") });
    setProviderSelect({ businessName: t("provider") });
    closeModal(false);
  };

  useEffect(() => {
    if (providerSelect?.id) {
      setFilters((prev) => ({
        ...prev,
        provider: providerSelect.id,
        agency: "all",
      }));
    }
  }, [providerSelect]);

  useEffect(() => {
    if (agencieSelect?.id) {
      setFilters((prev) => ({
        ...prev,
        provider: "all",
        agency: agencieSelect.id,
      }));
    }
  }, [agencieSelect]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("filter")}</p>
              <span>{t("filterConfig")}</span>
            </div>
            <CloseIcon
              onClick={handleClose}
              className={s.exitIcon}
              sx={{ color: "primary.dark" }}
            />
          </Grid>

          <div className={s.formFilters}>
            <div className={s.filter}>
              <TextField
                value={filters.number}
                label={t("deliveryNoteNumber")}
                sx={{ width: "80%" }}
                onChange={(e) =>
                  setFilters({ ...filters, number: e.target.value })
                }
                helperText={t("paramsIgnore")}
                type="number"
              />
            </div>

            <div className={s.filterByType}>
              <p>{t("type")}</p>
              <ToggleButtonGroup
                size="small"
                color="primary"
                value={filters.type}
                onChange={(e) =>
                  setFilters({ ...filters, type: e.target.value })
                }
                exclusive
              >
                <ToggleButton value="any">{t("all")}</ToggleButton>
                <ToggleButton value="Entrada">Entrada</ToggleButton>
                <ToggleButton value="Salida">Salida</ToggleButton>
              </ToggleButtonGroup>
            </div>

            <div className={s.filterByType}>
              <p>{t("state")}</p>
              <ToggleButtonGroup
                size="small"
                color="primary"
                value={filters.state}
                onChange={(e) =>
                  setFilters({ ...filters, state: e.target.value })
                }
                exclusive
              >
                <ToggleButton value="any">{t("all")}</ToggleButton>
                <ToggleButton value="Activo">Activo</ToggleButton>
                <ToggleButton value="Anulado">Anulado</ToggleButton>
                <ToggleButton value="En Proceso">En Proceso</ToggleButton>
              </ToggleButtonGroup>
            </div>

            <div className={s.filter}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={language}
              >
                <DesktopDatePicker
                  label={t("dischargeDate")}
                  value={filters.dateRemit}
                  inputFormat="DD/MM/YYYY"
                  inputProps={{
                    readOnly: true,
                  }}
                  onChange={(e) =>
                    setFilters({ ...filters, dateRemit: e.toISOString() })
                  }
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "80%" }} />
                  )}
                />
              </LocalizationProvider>
            </div>

            <div className={s.filter}>
              <FormControl sx={{ width: "25%" }}>
                <InputLabel id="select-label-provider">{t("type")}</InputLabel>
                <Select
                  labelId="select-label-provider"
                  value={search}
                  label={t("type")}
                  onChange={(e) => setSearch(e.target.value)}
                >
                  <MenuItem value={"proveedor"}>{t("provider")}</MenuItem>
                  <MenuItem value={"agencia"}>{t("agency")}</MenuItem>
                </Select>
              </FormControl>

              {search === "agencia" ? (
                <TextField
                  sx={{ width: "50%", ml: "5%" }}
                  value={agencieSelect?.name}
                  onClick={() => setOpenAgencyModal(true)}
                  disabled={true}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ cursor: "pointer" }} />
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              ) : (
                <TextField
                  sx={{ width: "50%", ml: "5%" }}
                  value={providerSelect?.businessName}
                  disabled={true}
                  onClick={() => setOpenProviderModal(true)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ cursor: "pointer" }} />
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              )}
              {openAgencyModal ? (
                <AgencyModal
                  open={openAgencyModal}
                  setOpen={setOpenAgencyModal}
                  selectAgency={setAgencieSelect}
                />
              ) : null}
              {openProviderModal ? (
                <ProvidersModal
                  open={openProviderModal}
                  setOpen={setOpenProviderModal}
                  selectProvider={setProviderSelect}
                />
              ) : null}
            </div>

            {/*<div className={s.filter}>*/}
            {/*    <FormControl sx={{width: '80%'}}>*/}
            {/*        <InputLabel id="select-label-game">{t('game')}</InputLabel>*/}
            {/*        <Select*/}
            {/*            labelId="select-label-game"*/}
            {/*            value={filters.game}*/}
            {/*            label={t('game')}*/}
            {/*            onChange={(e) => setFilters({...filters, game: e.target.value})}*/}
            {/*        >*/}
            {/*            <MenuItem value={'any'}>{t('allGames')}</MenuItem>*/}
            {/*            {reduxGames.map(g => (*/}
            {/*              <MenuItem value={g?.modality?.game?.id} key={g?.modality?.game?.id}>{g?.modality?.game?.name}</MenuItem>*/}
            {/*            ))}*/}
            {/*        </Select>*/}
            {/*    </FormControl>*/}
            {/*</div>*/}

            <div className={s.filter}>
              <TextField
                value={filters.orderID}
                label={t("purchaseOrder")}
                sx={{ width: "80%" }}
                type={"number"}
                onChange={(e) =>
                  setFilters({ ...filters, orderID: e.target.value * 1 })
                }
              />
            </div>

            <div className={s.filter}>
              <Button
                size="small"
                className={s.filterButton}
                variant="contained"
                color="primary"
                onClick={() => {
                  setNewFilters(filters);
                  setActualPage(1);
                  closeModal(false);
                  setSearching(true);
                }}
              >
                {t("apply")}
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default SearchModal;
